import { render, staticRenderFns } from "./ExamPhone.vue?vue&type=template&id=41d7f84f&scoped=true&"
import script from "./ExamPhone.vue?vue&type=script&lang=js&"
export * from "./ExamPhone.vue?vue&type=script&lang=js&"
import style0 from "./ExamPhone.vue?vue&type=style&index=0&id=41d7f84f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7f84f",
  null
  
)

component.options.__file = "ExamPhone.vue"
export default component.exports